import React from 'react';

/**
 * Пометка предложения с дополнительной услугой.
 *
 * Форте с 15.10.2026 отдаёт по одной заявке два решения: обычное и с услугой
 * «Помощь на дороге», стоимость которой уже включена в сумму займа. Внешне
 * карточки отличаются только суммой и платежом, поэтому без подписи менеджер
 * не поймёт, за что клиент доплачивает, и выберет наугад.
 */
export const hasRoadAssistance = (condition) => condition?.road_assistance === true;

export const roadAssistanceTitle = (condition) =>
  (condition?.road_assistance_name || '').trim() || 'Помощь на дороге';

const RoadAssistanceBadge = ({ condition }) => {
  if (!hasRoadAssistance(condition)) return null;

  return (
    <div
      style={{
        background: '#EAF6EC',
        border: '1px solid #9BCBA4',
        borderRadius: 6,
        padding: '8px 12px',
        marginBottom: 12,
        fontSize: 14,
      }}
    >
      <b>С услугой «{roadAssistanceTitle(condition)}»</b> — её стоимость уже включена в сумму займа
      и ежемесячный платёж.
    </div>
  );
};

export default RoadAssistanceBadge;
